import { type IBaseWidget } from '../../IBaseWidget.ts';
import { WidgetRepository } from '../WidgetRepository.ts';
import { type IInputWidget } from './IInputWidget.ts';

export function isInputWidget(widget: IBaseWidget): widget is IInputWidget {
  return WidgetRepository.find(widget.type)?.hasValue ?? false;
}
